import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';
  
@Injectable()
export class ViajeService extends RequestBaseService{
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'viaje'].join('/');
  }

  public getActivos(activo: number) {
    this.validate();

    return this.http
      .get([this.ApiUrl, 'activo', activo].join('/'))
      .map(res => res.json());        
  }

  public getTiquetes(viaje_id: number) {
    this.validate();

    return this.http
      .get([this.ApiUrl, viaje_id, 'tiquete'].join('/'))
      .map(res => res.json());
  }

  public getViajesBetweenDates(fechaInicial, fechaFinal) {
    this.validate();

    return this.http
      .get([this.ApiUrl, 'fecha', fechaInicial, fechaFinal].join('/'))
      .map(res => res.json());
  }

  public getMovimientos(fechaInicial, fechaFinal) {
    this.validate();

    return this.http
      .get([this.ApiUrl, 'movimientos', fechaInicial, fechaFinal].join('/'))
      .map(res => res.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/services/viaje/viaje.service.ts